import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=e85ad6ea&scoped=true&"
import script from "./overview.js?vue&type=script&lang=js&"
export * from "./overview.js?vue&type=script&lang=js&"
import style0 from "./overview.scss?vue&type=style&index=0&id=e85ad6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ad6ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e85ad6ea')) {
      api.createRecord('e85ad6ea', component.options)
    } else {
      api.reload('e85ad6ea', component.options)
    }
    module.hot.accept("./overview.vue?vue&type=template&id=e85ad6ea&scoped=true&", function () {
      api.rerender('e85ad6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Overview/overview.vue"
export default component.exports